<ng-container *ngIf="!loading && !participated">
  <ng-container *ngIf="displayHeader">
    <header class="participation-header">
      <span class="participation-header__date">
        <span class="participation-header__day">{{ model.scheduleStart | date: 'dd' }}</span>
        <span class="participation-header__month-and-year">
          <span class="participation-header__month">{{ model.scheduleStart | date: 'MMM' }}</span>
          <span class="participation-header__year">{{ model.scheduleStart | date: 'yyyy' }}</span>
        </span>
      </span>

      <div class="participation-header__title-and-time">
        <h3 class="participation-header__title">
          <event-i18n-event-type [model]="model.type"></event-i18n-event-type>
          <ng-container i18n>&nbsp;à</ng-container>
          {{ model.location.city }}
        </h3>

        <span class="participation-header__time">
          {{ model.scheduleStart | date: 'shortTime' }} - {{ model.scheduleEnd | date: 'shortTime' }}
        </span>
      </div>
    </header>

    <p class="participation-intro" [ngSwitch]="model.type">
      <ng-container *ngSwitchCase="'job_dating'" i18n>
        1er stage 1er job casse les codes des entretiens habituels, souvent sources de stress. C'est l'opportunité de
        vous mettre en valeur et de rencontrer plusieurs entreprises de votre région qui recrutent dans une ambiance
        conviviale et dans des lieux d'exception&nbsp;!
      </ng-container>
      <ng-container *ngSwitchCase="'cocktail_recrutement'" i18n>
        Les cocktails recrutement cassent les codes des entretiens habituels, souvent sources de stress. C'est
        l'opportunité de vous mettre en valeur et de rencontrer l'une des entreprises de votre région qui recrute dans
        une ambiance conviviale et dans des lieux d'exception&nbsp;!
      </ng-container>
      <ng-container *ngSwitchCase="'job_booster'" i18n>
        L'événement Job Booster c'est un vrai coup de boost pour votre carrière&nbsp;! De la pratique, de l’écoute, des
        outils et des conseils d’experts du secteur. Participez à trois ateliers différents et repartez avec votre photo
        pro, un tout nouveau CV rédigé par des professionnels et des conseils/astuces lors de mini-conférences. Et la
        bonne nouvelle est que c'est gratuit pour vous. Et tout ça, grâce à La Poste.
      </ng-container>
      <ng-container *ngSwitchDefault></ng-container>
    </p>
  </ng-container>

  <form #form="ngForm" class="participation-form" method="post" (ngSubmit)="form.valid && doSubmit(form.value)">
    <ng-template #messageRequiredField i18n>Ce champ est requis</ng-template>
    <ng-template #messageEmailInvalid i18n>L'adresse email est incorrecte</ng-template>

    <div class="participation-form__group">
      <div class="participation-form__infos">
        <ng-container *ngIf="!profile">
          <mat-form-field class="participation-form__field" [hideRequiredMarker]="true">
            <mat-label i18n>Prénom</mat-label>
            <input matInput type="text" name="firstName" [ngModel]="firstName" required />
            <mat-error>
              <ng-container *ngTemplateOutlet="messageRequiredField"></ng-container>
            </mat-error>
          </mat-form-field>

          <mat-form-field class="participation-form__field" [hideRequiredMarker]="true">
            <mat-label i18n>Nom</mat-label>
            <input matInput type="text" name="lastName" [ngModel]="lastName" required />
            <mat-error>
              <ng-container *ngTemplateOutlet="messageRequiredField"></ng-container>
            </mat-error>
          </mat-form-field>
        </ng-container>

        <mat-form-field class="participation-form__field" [hideRequiredMarker]="true">
          <mat-label i18n>Adresse email</mat-label>
          <input #email="ngModel" matInput type="email" name="mail" [ngModel]="profile?.email" required email />
          <mat-error>
            <ng-container
              *ngTemplateOutlet="email.hasError('required') ? messageRequiredField : messageEmailInvalid"
            ></ng-container>
          </mat-error>
        </mat-form-field>

        <mat-form-field class="participation-form__field" [hideRequiredMarker]="true">
          <mat-label i18n>Numéro de téléphone</mat-label>
          <input matInput type="text" name="phone" [ngModel]="profile?.mobile" required />
          <mat-error>
            <ng-container *ngTemplateOutlet="messageRequiredField"></ng-container>
          </mat-error>
        </mat-form-field>

        <app-checkbox
          #rightsConsent="ngModel"
          *ngIf="model?.type === 'evenement_prive'"
          class="participation-form__consent"
          name="rightsConsent"
          [(ngModel)]="checkboxValue"
          required
          i18n
        >
          J’accepte que les informations saisies soient utilisées par les organisateurs, dans le cadre de ma
          candidature.
        </app-checkbox>

        <app-checkbox
          #rightsConsent="ngModel"
          *ngIf="model?.type === 'job_dating' || model?.type === 'job_booster'"
          class="participation-form__consent"
          name="rightsConsent"
          [(ngModel)]="checkboxValue"
          i18n
        >
          J'accepte que les informations saisies soient utilisées par les organisateurs, dans le cadre de ma
          participation au {{ model?.type === 'job_dating' ? 'Job Dating' : 'Job Booster' }} et de la relation
          commerciale qui peut en découler.
        </app-checkbox>

        <p
          *ngIf="model?.type === 'evenement_prive' && !checkboxValue && form.submitted"
          class="participation-form__consent--error"
          role="alert"
        >
          Ce champs est requis
        </p>
      </div>

      <div class="participation-form__cv">
        <label for="cv-picker" class="participation-form__cv-label" i18n>Envoyez votre CV&nbsp;:</label>
        <app-carousel
          id="cv-picker"
          type="carousel"
          name="resumeFileId"
          [(ngModel)]="cv"
          [moveEvent]="{
            eventCategory: 'Search Events',
            eventAction: 'Click CV Arrows'
          }"
        >
          <app-carousel-slide *ngFor="let file of files; trackBy: trackByIndex" [value]="file.id">
            <app-wiz-file
              [model]="file"
              [editable]="false"
              [uploadPercentage]="!file.id ? (uploadPercent$ | async) : null"
            >
              <ng-container *ngIf="!file.name">
                <app-file-input
                  [class.cv-error]="error"
                  name="newfile"
                  #fileInput="ngModel"
                  ngModel
                  (ngModelChange)="addNewSlot($event, fileInput)"
                  [openFilePickerEvent]="{
                    eventCategory: 'Search Events',
                    eventAction: 'Click CV Pick'
                  }"
                ></app-file-input>
                <p *ngIf="error === FileInputError.InvalidFormat" class="cv-error cv-error__label" i18n>
                  Format invalide
                </p>
                <p *ngIf="error === FileInputError.MaxSizeExceeded" class="cv-error cv-error__label" i18n>
                  Fichier trop volumineux
                </p>
              </ng-container>
            </app-wiz-file>
          </app-carousel-slide>
        </app-carousel>
      </div>
    </div>

    <footer class="participation-form__footer">
      <button
        class="btn participation-form__btn"
        [class.participation-form__btn]="!profile && model.type === 'job_dating'"
        type="submit"
        appEventTracker
        eventCategory="Search Events"
        eventAction="Click Pre-Register"
      >
        <ng-container i18n>Envoyer ma candidature</ng-container>
        <app-svg-icon class="btn__icon" icon="exp-right" width="1.25em" height="0.75em"></app-svg-icon>
      </button>

      <p *ngIf="!profile" class="participation-form__notice" i18n>
        En cliquant sur Envoyer ma candidature, vous acceptez les
        <a class="participation-form__notice-link" [href]="cguUrl" target="_blank" rel="noopener">CGU</a> et la
        <a class="participation-form__notice-link" [href]="policyUrl" target="_blank" rel="noopener"
          >Politique de Confidentialité</a
        >
        de WIZBII.
      </p>
    </footer>
  </form>
</ng-container>

<div *ngIf="loading || participated" class="participation-success">
  <app-checkmark-loader class="participation-success__loader" [loading]="loading" i18n>
    Inscription en cours...
  </app-checkmark-loader>
  <div class="participation-success__content" [attr.aria-hidden]="loading">
    <h3 class="participation-success__title" i18n>Inscription terminée&nbsp;!</h3>
    <p class="participation-success__text" i18n>
      Merci. Votre demande d'inscription a bien été enregistrée. Notre équipe reviendra vers vous très rapidement&nbsp;!
    </p>
    <a
      *ngIf="!isClosePresent"
      class="participation-success__close btn"
      [routerLink]="[returnToHome ? jobsPath : '.']"
      [queryParams]="{ 'event-participation': undefined }"
      queryParamsHandling="merge"
      fragment="keep-scrolled"
      i18n
      appEventTracker
      eventCategory="Search Events"
      eventAction="Click Close"
      eventLabel="Button"
      >Fermer</a
    >
    <button *ngIf="isClosePresent" class="participation-success__close btn" (click)="closeForm.emit()" i18n>
      Fermer
    </button>
  </div>
</div>
